/*
 * OWKA — Repli des blocs longs sur mobile
 * ---------------------------------------------------------------
 * 77,5 % du trafic est mobile. Les fiches produit et les articles
 * portent des guides de plusieurs milliers de mots qui repoussent
 * tout le reste : le visiteur scrolle sans fin ou abandonne.
 *
 * Ce script replie ces blocs derrière un bouton, sur mobile
 * uniquement. Le contenu reste entièrement dans le HTML — rien
 * n'est retiré de l'index, seul l'affichage initial change.
 *
 * Le CSS (.owka-collapsible / .owka-readmore) vit dans le bloc
 * {% style %} de layout/theme.liquid.
 */
(function () {
  'use strict';

  var BREAKPOINT = 750;

  // Chaque cible a son propre seuil : on ne replie que ce qui est
  // réellement encombrant, et on laisse respirer les blocs courts.
  var TARGETS = [
    { selector: '.owka-longread',           minHeight: 420, label: 'Lire le guide complet' },
    { selector: '.owka-guide-container',     minHeight: 420, label: 'Lire le guide complet' },
    { selector: '.owka-custom-seo-wrapper',  minHeight: 420, label: 'Lire le guide complet' },
    { selector: '.product__description',     minHeight: 600, label: 'Lire la description complète' },
    { selector: '.collection-description',   minHeight: 320, label: 'Lire la suite' },
    { selector: '.collection .rte',          minHeight: 320, label: 'Lire la suite' }
  ];

  function collapse(block, label) {
    if (block.dataset.owkaCollapsible === 'true') return;
    block.dataset.owkaCollapsible = 'true';
    block.classList.add('owka-collapsible');

    if (!block.id) {
      block.id = 'owka-longread-' + Math.random().toString(36).slice(2, 9);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'owka-readmore';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', block.id);
    button.textContent = '\u25BC ' + label;

    block.parentNode.insertBefore(button, block.nextSibling);

    button.addEventListener('click', function () {
      var expanded = block.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = (expanded ? '\u25B2 R\u00e9duire' : '\u25BC ' + label);

      // En repliant, on ramène le lecteur au bouton plutôt que de le
      // laisser perdu au milieu de la page.
      if (!expanded) {
        var top = button.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  }

  function init() {
    if (window.innerWidth >= BREAKPOINT) return;

    TARGETS.forEach(function (target) {
      var blocks = document.querySelectorAll(target.selector);
      Array.prototype.forEach.call(blocks, function (block) {
        // Ne pas replier un bloc déjà contenu dans un autre repli.
        if (block.closest('.owka-collapsible')) return;
        if (block.scrollHeight <= target.minHeight) return;
        collapse(block, target.label);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Le contenu produit peut être re-rendu au changement de variante.
  document.addEventListener('shopify:section:load', init);
})();
